// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyCkDE84UK1cj_dDM71OoQTTrvL5f7YxZ3I",
    authDomain: "alke-prod.firebaseapp.com",
    projectId: "alke-prod",
    storageBucket: "alke-prod.appspot.com",
    messagingSenderId: "290103493661",
    appId: "1:290103493661:web:52fd8133fff36dea2ab2f4",
    measurementId: "G-PKW8VYMHZ3"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
